import React from "react";
import { useData } from "@/context/DataContext";

export default function PromoBanner() {
  const { promotions } = useData();
  if (!promotions?.length) return null;
  const loop = [...promotions, ...promotions, ...promotions, ...promotions];
  return (
    <div className="bg-amber-400 text-[#0A2818] overflow-hidden py-2.5 border-y border-amber-500" data-testid="promo-banner">
      <div className="flex whitespace-nowrap animate-marquee">
        {loop.map((p, i) => (
          <span key={`${p.promo_id || p.text}-${i}`} className="mx-8 font-display font-black uppercase tracking-wider text-sm flex items-center gap-3">
            <i className="fa-solid fa-star text-[10px]" /> {p.text}
          </span>
        ))}
      </div>
    </div>
  );
}
